import { env } from '~/helpers/env'

/**
 * Ouvre dans un nouvel onglet l'aperçu d'un modèle avec les valeurs du
 * formulaire, non enregistrées, par-dessus son logo et son fond (#162).
 */
export async function openCertificatePreview(templateId: string, input: object): Promise<void> {
  const res = await fetch(`${env.api.url}/certificates/preview?templateId=${encodeURIComponent(templateId)}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(input),
  })
  if (!res.ok) throw new Error(`preview failed (${res.status})`)
  const url = URL.createObjectURL(await res.blob())
  window.open(url, '_blank', 'noopener')
  // Laisse le temps au nouvel onglet de charger le blob avant révocation.
  setTimeout(() => URL.revokeObjectURL(url), 60_000)
}
